import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
 
const PrnRequestCreate = ()=>{
    const [transDate, setTransDate ] = useState('');
    const [amount, setAmount ] = useState('');
    const [taxType, setTaxType ] = useState(''); 
    const [redirect, setRedirect] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const[loading, setLoading] = useState(false);
    const [hasError,setHasError] = useState(false);
    const submit = async (e)=>{
         e.preventDefault();
         setLoading(true);
         
         try {
            const {data} = await axios.post('prnRequest', {
                transDate,
                amount,
                taxType,
                salt:"bEWbd2b8aDFj3jpcTcdbf6b32dq6ef900",
            });
           // console.log(data);
           setHasError(false);
        setRedirect(true);

        } catch (error) {
            //console.log(error.code);
            if (error.message === "Network Error") {
            setErrorMessage("Failed to connect to the server. Please try again later.");
        } else if(error.code==="ERR_BAD_REQUEST"){
            setErrorMessage("Wrong Email or password. Try again");
        } else {
            setErrorMessage("An error occurred. Please try again later.");
        } 
        setHasError(true)
        }finally{
        setLoading(false);
        }

         
    }

    if(redirect){
        return <Navigate to={'/prnRequest'} />
    }
     return (
         <Wrapper pageTitle={"New PrnRequest"}>
            <InnerNav createLink={'/prnRequestCreate'} listLink={'/prnRequest'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TransDate </span>
                        <input type="date"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TransDate"
                        onChange = {e => setTransDate(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Amount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Amount"
                        onChange = {e => setAmount(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TaxType </span>
                        
<select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        
                        onChange = {e => setTaxType(e.target.value)} >
                           <option value="0">Choose Tax Type</option> 
                           <option value="EXCISE">EXCISE [DEPOSITS]</option>
                           <option value="IT_WHT_0222">WITHOLDING [WITHDRAWALS]</option>
                           
                            </select>
                    </label>
 

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        

                        <button
                    className={`className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"`}
                    onClick={submit}
                    disabled={loading}
                >
                     {loading ? 'Loading...' : 'Request'}
                </button>
                {hasError&&
                (
                <div className="bg-red-500 text-white leading-5 text-center mt-4 text-sm  px-4 py-2">
                    {errorMessage}
                </div>
                )
                }
                

                        </label>
                    </div>
                </div>
             </form>

             
        </Wrapper>
     );
};
export default PrnRequestCreate;